import { Component, forwardRef, inject, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { A11yLabelDirective } from 'app/shared/accessibility/directives/a11y-label.directive';
import { BaseControlDirective } from 'app/shared/directives/control/base-control.directive';

@Component({
  selector: 'kh-common-checkbox',
  templateUrl: './common-checkbox.component.html',
  styleUrls: ['./common-checkbox.component.less'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CommonCheckboxComponent),
    multi: true
  }],
  standalone: false
})

export class CommonCheckboxComponent extends BaseControlDirective<boolean> {
  private readonly a11yLabel = inject(A11yLabelDirective, { optional: true, self: true });

  @Input() public id = 'common-checkbox';
  @Input() public isClickableLabel = false;

  public get accessibleLabel(): string | null {
    return this.a11yLabel?.ariaLabel ?? null;
  }
}
